module.exports = __webpack_public_path__ + "img/snyg@2X.6818b0b8.png";